import {
  Box,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import { FileCopyOutlined } from '@material-ui/icons';
import EyeDisabledIcon from 'images/icons/objects/eyes/disableView.svg';
import EyeEnabledIcon from 'images/icons/objects/eyes/iconView.svg';
import CloseIconNavy from 'images/icons/signals/closesAndCancels/closeTransparent.svg';
import { useState } from 'react';
import Draggable from 'react-draggable';
import { PrintParametersDialogContainer } from '../../styles';
import { Link } from 'react-router-dom';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggableLabelPrintingParametersDialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} style={{ ...props?.style, maxWidth: 850 }} />
    </Draggable>
  );
}

function CopyLinkButton({ link }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error('Erro ao copiar:', err);
    }
  };

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: 'underline',
          color: '#5061F0',
          wordBreak: 'break-all'
        }}
      >
        {link}
      </a>

      <IconButton size="small" onClick={handleCopy} style={{ marginLeft: 4 }}>
        <FileCopyOutlined
          fontSize="small"
          style={{ color: copied ? '#038e1a' : '#5061F0' }}
        />
      </IconButton>
      {copied && (
        <Typography variant="body2" style={{ color: '#038e1a' }}>
          Copiado
        </Typography>
      )}
    </Box>
  );
}

function PrintParametersDialog({ open, onClose, manufactures }) {
  const isMobileScreen = useMediaQuery('(max-width: 866px)');
  const isSmallTablet = useMediaQuery('(max-width: 602px)');
  const isPhoneScreen = useMediaQuery('(max-width: 576px)');
  const [showPassword, setShowPassword] = useState(false);

  return (
    <PrintParametersDialogContainer
      open={open}
      className="defaultModal"
      onClose={() => {
        onClose();
      }}
      maxWidth="md"
      fullWidth
      PaperComponent={PaperComponent}
    >
      <DialogTitle
        className="modalHeader bold textAlignCenter cursorMove navyBlue"
        style={{ backgroundColor: '#1F2445' }}
      >
        <Typography
          id="draggableLabelPrintingParametersDialog"
          className="w100 textAlignLeft"
        >
          PARÂMETROS DE IMPRESSÃO
        </Typography>

        <IconButton
          style={{ outline: '0', background: 'none', align: 'right' }}
          onClick={() => {
            onClose();
          }}
        >
          <img
            onClick={() => {
              onClose();
            }}
            style={{ width: '16px' }}
            src={CloseIconNavy}
            alt="CloseIconNavy"
          />
        </IconButton>
      </DialogTitle>

      {!manufactures && <LinearProgress />}

      <DialogContent
        style={{
          paddingBlock: 20,
          paddingBottom: 15,
          paddingInline: 10,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {Boolean(manufactures) && (
          <Paper
            elevation={3}
            style={{
              padding: 20,
              paddingBlock: 10,
              paddingBottom: 15,
              flex: 1,
              height: '100%'
            }}
          >
            <Box
              mb={1}
              style={{ display: 'flex', alignItems: 'center', gap: 10 }}
            >
              <Typography
                style={{ marginBottom: 2, fontWeight: 500, fontSize: 15 }}
              >
                Link para baixar Bloom Printer:
              </Typography>
              <CopyLinkButton
                link={
                  manufactures.typePrint == 'QUEUE'
                    ? 'https://bloom-sdk.s3.us-east-2.amazonaws.com/BloomPrinterInstall.msi'
                    : 'https://bloom-sdk.s3.us-east-2.amazonaws.com/app.apk'
                }
              />
            </Box>

            <Box
              style={{
                display: 'flex',
                flexDirection: isSmallTablet ? 'column' : 'row',
                alignItems: isSmallTablet ? 'flex-start' : 'center',
                gap: 10
              }}
            >
              <Typography style={{ fontWeight: 500, fontSize: 15 }}>
                Login Bloom Printer:
              </Typography>
              <Box display="flex" alignItems={'center'} gap={20}>
                <Typography style={{ marginRight: '10px' }} variant="body2">
                  <span style={{ fontWeight: 500, color: '#666770' }}>
                    USUÁRIO:
                  </span>
                </Typography>
                <TextField
                  hiddenLabel
                  size="small"
                  value={manufactures?.username || ''}
                  InputProps={{
                    readOnly: true,
                    style: {
                      fontWeight: 500,
                      borderBottom: '1px solid #5062F0',
                      color: '#797979'
                    }
                  }}
                  style={{ width: 150, marginTop: 3 }}
                  variant="standard"
                />
                <Typography variant="body2" style={{ marginInline: '10px' }}>
                  <span style={{ fontWeight: 500, color: '#666770' }}>
                    SENHA
                  </span>
                </Typography>
                <TextField
                  hiddenLabel
                  size="small"
                  value={
                    showPassword ? manufactures?.password || '' : '********'
                  }
                  InputProps={{
                    readOnly: true,
                    style: {
                      fontWeight: 500,
                      borderBottom: '1px solid #5062F0'
                    }
                  }}
                  style={{ width: 120, marginTop: 3 }}
                  variant="standard"
                />
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    height: 35,
                    width: 35,
                    padding: 0.1,
                    marginTop: '3px'
                  }}
                >
                  <img
                    width={25}
                    src={showPassword ? EyeEnabledIcon : EyeDisabledIcon}
                  />
                </IconButton>
              </Box>
            </Box>
          </Paper>
        )}
      </DialogContent>
    </PrintParametersDialogContainer>
  );
}

export default PrintParametersDialog;
